// A response belongs to one account, symbol, interval and selection generation.
// A -> B -> A must not make an in-flight response for the first A valid again.
export function createChartSubscriptionTracker(sessionId = `${Date.now()}-${Math.random().toString(36).slice(2)}`) {
  let sequence = 0;
  let key;
  let current = null;
  return {
    select({ userId, symbol, timeFrame, category }) {
      const nextKey = JSON.stringify([String(userId || ''), symbol, timeFrame, String(category || '')]);
      if (key !== nextKey) {
        key = nextKey;
        sequence += 1;
        current = Number(userId) > 0 && symbol && timeFrame && category
          ? { userId: String(userId), symbol, timeFrame, category, requestId: `${sessionId}:${sequence}` }
          : null;
      }
      return current;
    },
  };
}

export function matchesChartSubscription(packet, subscription) {
  if (!packet || !subscription) return false;
  const symbol = packet.s || packet.symbol?.s || packet.symbol?.name || packet.selectedSymbolName || packet.symbolName;
  return packet.requestId === subscription.requestId
    && String(packet.user ?? packet.userId ?? '') === subscription.userId
    && symbol === subscription.symbol
    && packet.timeFrame === subscription.timeFrame;
}

// Remove a stale candle before child effects can consume it. Other account data
// and the selected-symbol quote packet are handled by their existing owners.
export function clearStaleChartPacket(data, subscription) {
  if (data[1] == null || matchesChartSubscription(data[1], subscription)) return data;
  const next = [...data];
  next[1] = null;
  return next;
}

// Install once per provider, while dispatching to the latest render's handlers.
export function listenToPlatformEvents(target, getHandlers) {
  const callbacks = new Map([
    ['connectionOpened', event => getHandlers().opened?.(event)],
    ['connectionClosed', event => getHandlers().closed?.(event)],
    ['ws_message_platform', event => getHandlers().message?.(event)],
  ]);
  callbacks.forEach((callback, name) => target.addEventListener(name, callback));
  return () => callbacks.forEach((callback, name) => target.removeEventListener(name, callback));
}
